import {extractDocs} from '~/utils/transform-payload'

export function useJobs() {
  const {t} = useI18n()
  const sdk = usePayloadSdk()

  const fetch = async () => {
    const response = await sdk.find({
      collection: 'jobs',
      depth: 1, // Populates icon and single_job_person relationships
      limit: 1000,
      where: {
        _status: {equals: 'published'},
      },
    })

    return extractDocs(response)
  }

  const fetchBySlug = async (slug: string) => {
    const response = await sdk.find({
      collection: 'jobs',
      depth: 1,
      limit: 1000,
    })

    const jobs = extractDocs(response)
    const currentJob = jobs.find(job => job.slug === slug)

    if (!currentJob) return null

    const currentIndex = jobs.findIndex(job => job.slug === slug)
    const jobsNumber = jobs.length
    const previousSlugIndex = currentIndex > 0 ? currentIndex - 1 : jobsNumber - 1
    const nextSlugIndex = currentIndex < jobsNumber - 1 ? currentIndex + 1 : 0

    return {
      job: currentJob,
      previousSlug: jobs[previousSlugIndex]?.slug ?? '',
      nextSlug: jobs[nextSlugIndex]?.slug ?? '',
      meta: {
        title: currentJob.title,
        description: `${t('careers.jobs.single.description.1')} ${currentJob.title}${t(
          'careers.jobs.single.description.2'
        )}`,
      },
    }
  }

  return {
    fetch,
    fetchBySlug,
  }
}
